/** @jsxImportSource theme-ui */
import * as React from "react";
import { ThemeProvider } from "../stylingLib";
import { theme } from "./theme";

export const NessieThemeProvider = ({ children }: { children?: React.ReactNode }) => (
  <ThemeProvider theme={theme}>{children}</ThemeProvider>
);
